/* eslint-disable camelcase */
import { Map } from 'immutable';
import { call, select } from 'redux-saga/effects';
import { locationQuerySelector } from 'ctm-selectors';
import { buildUrlWithParams } from 'ctm-util-functions';
import { processRequestAndActionsSaga, processSagaWithRetries } from './utils';

/**
 * Saga for loading the Journey data from the backend in the redux store using the api settings set in the schema.
 * @param {Object} action - The action that describes the request.
 */
export const processLoadJourneyAction = function* (action) {
    const querySelector = yield select(locationQuerySelector);
    const queryParams = yield call(_getQueryParams, querySelector);

    // Append the rest of params to the queryString
    // eslint-disable-next-line no-param-reassign
    action.url = yield call(buildUrlWithParams, action.url, queryParams);
    yield call(processSagaWithRetries, processRequestAndActionsSaga, action);
};

/**
 * Private get function so we can do better unit test with mocking state, exported for testing purpose
 * @param {Map} querySelector - querySelector from the state
 * @returns {Object} queryParams object
 * @private
 */
export const _getQueryParams = (querySelector) => {
    const { journey_id, quote_id, product_id, transaction_id, payment_frequency, source } = querySelector.toJS();
    return { journey_id, quote_id, product_id, transaction_id, payment_frequency, source };
};
